t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_more')

module.exports = t.renderable ({ shortUrl, editableByMember, isLoggedIn, canCloseOrLeave, canCloseBoard, canCopyBoard,
canLeaveBoard, pLevelAltText, pLevelClass, helperText, showCollections, templateFlagEnabled,
isTemplate, templateModeEnabled, hasMadeTemplate, canBeTemplate, isOrgBcOrEnt }) ->
  t.ul '.board-menu-navigation', ->

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-settings', { href: '#' }, ->
        t.icon 'gear', 'settings', { class: 'board-menu-navigation-item-link-icon' }

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-labels', { href: '#' }, ->
        t.icon 'label', 'labels', { class: 'board-menu-navigation-item-link-icon' }

    if showCollections
      t.li '.board-menu-navigation-item', ->
        if isOrgBcOrEnt
          t.a '.board-menu-navigation-item-link.js-open-collections', { href: '#' }, ->
            t.icon 'collection', 'collections', { class: 'board-menu-navigation-item-link-icon' }
        else
          t.span '.board-menu-navigation-item-link.disabled', ->
            t.icon 'collection', 'collections', { class: 'board-menu-navigation-item-link-icon' }
            t.div '.board-menu-pill-collections-upgrade.js-board-menu-pill-collections-upgrade'
          t.div '.board-menu-prompt-collections.js-board-menu-prompt-collections'

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-open-archive', { href: '#' }, ->
        t.icon 'archive', 'archived-items', { class: 'board-menu-navigation-item-link-icon' }

  t.hr()

  t.ul '.board-menu-navigation', ->

    if editableByMember && !templateModeEnabled
      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-email', { href: '#' }, ->
          t.icon 'email', 'email-to-board-settings', { class: 'board-menu-navigation-item-link-icon' }

    if isLoggedIn && !templateModeEnabled
      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-board-subscribe', { href: '#' }, ->
          t.icon 'subscribe', 'watch', { class: 'board-menu-navigation-item-link-icon' }
          t.raw '&nbsp;'
          t.span '.js-subscribed-state', ->
            t.icon 'check'

      if canCopyBoard
        t.li '.board-menu-navigation-item', ->
          t.a '.board-menu-navigation-item-link.js-copy-board', { href: '#' }, ->
            t.icon 'copy', 'copy-board', { class: 'board-menu-navigation-item-link-icon' }

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link.js-share', { href: '#' }, ->
        t.icon 'share', 'print-and-export', { class: 'board-menu-navigation-item-link-icon' }

    # Template toggle
    if canBeTemplate && templateFlagEnabled && editableByMember
      t.li '.board-menu-navigation-item', ->
        if isTemplate
          t.a '.board-menu-navigation-item-link.js-convert-to-board', { href: '#' }, ->
            t.icon 'board', { class: 'board-menu-navigation-item-link-icon' }
            t.format 'convert-to-board'
        else
          t.a '.board-menu-navigation-item-link.js-create-template', { href: '#' }, ->
            t.icon 'template-board', { class: 'board-menu-navigation-item-link-icon' }
            t.format 'create-template'
            if !hasMadeTemplate
              t.span '.board-menu-navigation-item-new', ->
                t.format 'new'

  if canCloseOrLeave

    t.hr()

    t.ul '.board-menu-navigation', ->

      if canCloseBoard
        t.li '.board-menu-navigation-item', ->
          t.a '.board-menu-navigation-item-link.js-close-board', { href: '#' }, ->
            t.raw '&nbsp;'
            if templateModeEnabled
              t.format 'close-template-ellipsis'
            else
              t.format 'close-board-ellipsis'

      if canLeaveBoard
        t.li '.board-menu-navigation-item', ->
          t.a '.board-menu-navigation-item-link.js-leave-board', { href: '#' }, ->
            t.raw '&nbsp;'
            t.format 'leave-board-ellipsis'

  t.hr()

  t.form '.u-gutter', ->

    t.label { for: 'id-short-url' }, ->
      if templateModeEnabled
        t.format 'link-to-this-template'
      else
        t.format 'link-to-this-board'

    t.input '.js-short-url', { type: 'text', readonly: 'readonly', id: 'id-short-url', value: shortUrl }

    t.p '.quiet', ->
      t.span { class: 'icon-sm icon-' + pLevelClass, title: pLevelAltText }
      t.text helperText
